(function () {
  'use strict';
  /* Queen Shaped - Find my size.

     Body-measurement chart for M-6XL, graded off Australian dress sizing
     (M = AU 12-14, each letter size = two dress sizes = 10cm). These are BODY
     measurements, not garment measurements - the per-product garment table is
     what the Size Guide shows.

     Height and weight give a starting estimate only; the shopper adjusts it on
     step 2, and that adjusted figure is what the recommendation uses. Nothing
     leaves the browser - the answers are kept in localStorage on this device. */

  var KEY = 'qs-fit-v1';
  var SIZES = [
    { code: 'M',   au: '12–14', us: '8–10',  bust: [92, 99],   waist: [74, 81],   hip: [99, 106] },
    { code: 'L',   au: '16–18', us: '12–14', bust: [100, 109], waist: [82, 91],   hip: [107, 116] },
    { code: 'XL',  au: '20–22', us: '16–18', bust: [110, 119], waist: [92, 101],  hip: [117, 126] },
    { code: '2XL', au: '24–26', us: '20–22', bust: [120, 129], waist: [102, 111], hip: [127, 136] },
    { code: '3XL', au: '28–30', us: '24–26', bust: [130, 139], waist: [112, 121], hip: [137, 146] },
    { code: '4XL', au: '32–34', us: '28–30', bust: [140, 149], waist: [122, 131], hip: [147, 156] },
    { code: '5XL', au: '36–38', us: '32–34', bust: [150, 159], waist: [132, 141], hip: [157, 166] },
    { code: '6XL', au: '40–42', us: '36–38', bust: [160, 169], waist: [142, 151], hip: [167, 176] }
  ];
  var ZONES = [['bust', 'Bust'], ['waist', 'Waist'], ['hip', 'Hip']];

  function clamp(v, lo, hi) { return Math.min(hi, Math.max(lo, v)); }

  /* Anchored on AU 12 at 165cm / 65kg, then graded: about 1 dress size per 4kg,
     and a touch smaller for the same weight carried on a taller frame. */
  function estimate(h, w) {
    var dw = w - 65, dh = h - 165;
    return {
      bust:  clamp(Math.round(92 + 0.65 * dw - 0.31 * dh), 76, 185),
      waist: clamp(Math.round(74 + 0.75 * dw - 0.28 * dh), 58, 175),
      hip:   clamp(Math.round(99 + 0.62 * dw - 0.30 * dh), 80, 190)
    };
  }

  function indexFor(v, key) {
    for (var i = 0; i < SIZES.length; i++) { if (v <= SIZES[i][key][1]) return i; }
    return SIZES.length - 1;
  }
  /* The size that accommodates the largest of the three - erring upward, which
     is also what the size guide tells people to do when they are between sizes. */
  function recommend(m) {
    return Math.max(indexFor(m.bust, 'bust'), indexFor(m.waist, 'waist'), indexFor(m.hip, 'hip'));
  }

  function verdict(v, band) {
    var mid = (band[0] + band[1]) / 2;
    if (v > band[1] + 3) return 'Too tight';
    if (v > band[1]) return 'Snug';
    if (v > mid) return 'Fitted';
    if (v >= band[0]) return 'Just right';
    if (v >= band[0] - 6) return 'Relaxed';
    return 'Loose';
  }

  function load() {
    try { return JSON.parse(localStorage.getItem(KEY)) || null; } catch (e) { return null; }
  }
  function save(d) {
    try { localStorage.setItem(KEY, JSON.stringify(d)); } catch (e) {}
  }

  /* ---------- the product's own size options ---------- */
  function normalise(s) {
    var t = (s || '').toUpperCase().replace(/[\s.\-]/g, '');
    if (t === 'XXL') return '2XL';
    if (t === 'XXXL') return '3XL';
    if (t === 'XXXXL') return '4XL';
    var m = t.match(/^(\d)X$/);
    if (m) return m[1] + 'XL';
    return t;
  }
  function sizeFieldset() {
    var all = document.querySelectorAll('fieldset.variant-option');
    for (var i = 0; i < all.length; i++) {
      var lg = all[i].querySelector('legend');
      if (lg && /size|storlek|taille/i.test(lg.textContent)) return all[i];
    }
    return null;
  }
  /* Swatch King (an app embed) replaces Horizon's native picker: it sets
     <variant-picker> to display:none and renders its own radiogroup. Where it is
     present the visible controls are its own, so we have to read and click those
     - ticking the hidden native input alone leaves its UI showing the old size. */
  function skRoot() {
    var all = document.querySelectorAll('[id^="swatch-option"][option-name]');
    for (var i = 0; i < all.length; i++) {
      if (/size|storlek|taille/i.test(all[i].getAttribute('option-name') || '')) return all[i];
    }
    return null;
  }
  /* whichever size picker the shopper actually sees */
  function sizeAnchor() { return skRoot() || sizeFieldset(); }

  function soldOut(el, input) {
    var c = el ? String(el.className) : '';
    return !!(c.indexOf('unavailable') > -1 || c.indexOf('sold') > -1 ||
      (el && el.getAttribute('aria-disabled') === 'true') ||
      (input && (input.disabled || input.getAttribute('aria-disabled') === 'true')));
  }
  function nativeOptions() {
    var fs = sizeFieldset(), out = [];
    if (!fs) return out;
    fs.querySelectorAll('label').forEach(function (el) {
      var input = el.querySelector('input');
      var txt = el.querySelector('.variant-option__button-label__text');
      var name = (txt && txt.textContent.trim()) || (input && input.value) || '';
      if (!name) return;
      /* Horizon marks a sold-out option with aria-disabled on the input,
         not a class or the disabled property. */
      out.push({ code: normalise(name), label: name, el: el, input: input, sold: soldOut(el, input) });
    });
    return out;
  }
  function options() {
    var sk = skRoot(), base = nativeOptions();
    if (!sk) return base;
    /* the native picker stays in the DOM even when hidden, and it is the
       server-rendered source of truth for what is in stock */
    var by = {};
    base.forEach(function (o) { by[o.code] = o; });
    var out = [];
    sk.querySelectorAll('li[orig-value]').forEach(function (li) {
      var name = li.getAttribute('orig-value');
      if (!name) return;
      var code = normalise(name), n = by[code];
      out.push({
        code: code,
        label: name,
        el: li.querySelector('.swatch-button') || li,
        input: n && n.input,
        sold: soldOut(li, n && n.input) || !!(n && n.sold)
      });
    });
    return out.length ? out : base;
  }
  function choose(code) {
    var opts = options();
    for (var i = 0; i < opts.length; i++) {
      if (opts[i].code === code && !opts[i].sold) { opts[i].el.click(); return true; }
    }
    return false;
  }

  window.QSFit = {
    SIZES: SIZES, ZONES: ZONES, clamp: clamp, estimate: estimate,
    recommend: recommend, verdict: verdict, load: load, save: save,
    options: options, choose: choose, sizeAnchor: sizeAnchor
  };
})();
